module.exports = __webpack_public_path__ + "img/Lacoste.f91ddaf6.jpg";